/*
  用于控制移动端左侧侧滑菜单显示与隐藏
 */
import { mapGetters, mapMutations } from 'vuex';
import { mutationTypes } from '../../store/mutation-types';
import tool from '../../common/js/tool';
export default {
  methods: {
    ...mapMutations([mutationTypes.SET_SLIDERMENUCONTROLS]),
  },
  computed: {
    ...mapGetters(['GET_SLIDERMENU_CONTROLS']),
    leftDrawerShow: {
      get () {
        let flag = this.GET_SLIDERMENU_CONTROLS[this.sliderMenuId];
        let browser = tool.browser();
        let body;

        /* iphone中，fixed元素有滚动条，滚动时会触发body也滚动 */
        if (browser.isIphone || browser.iPad) {
          body = document.body;
          body.style.height = window.innerHeight + 'px';
          tool.addClass(body, 'no-scroll');
          body = null;
        }
        return flag;
      },
      set (val) {
        let browser = tool.browser();
        let body;
        if (browser.isIphone || browser.iPad) {
          body = document.body;
          body.style.height = 'auto';
          tool.removeClass(body, 'no-scroll');
          body = null;
        }
        this.SET_SLIDERMENUCONTROLS(this.sliderMenuId + '-' + val);
      },
    },
  },
  mounted () {
    let sliderMenuId = this.sliderMenuId;
    if (!sliderMenuId) {
      console.error('data 中必须有 sliderMenuId 属性，否则无法控制左侧侧滑菜单！');
    }
  },
};
